import React, { useState } from "react";
import { usePacientes } from "../hooks/usePacientes";

const MisPacientes = ({ onEdit, showToast, onViewHistory, activeProjectId }) => {
    const { pacientes, loading, deletePaciente } = usePacientes(activeProjectId);
    const [searchTerm, setSearchTerm] = useState("");
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(null);

    const handleDelete = async (id) => {
        try {
            await deletePaciente(id);
            showToast("Paciente eliminado correctamente", "success");
            setShowDeleteConfirm(null);
        } catch (err) {
            showToast("Error al eliminar paciente. Puede tener casos asociados.", "danger");
            setShowDeleteConfirm(null);
        }
    };

    const filtered = pacientes.filter(p =>
        p.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        p.documento.includes(searchTerm)
    );

    return (
        <div className="animate__animated animate__fadeIn">
            <div className="researcher-toolbar justify-content-between">
                <div className="researcher-search-wrapper">
                    <i className="bi bi-search"></i>
                    <input
                        type="text"
                        className="researcher-search-input"
                        placeholder="Buscar por nombre o ID del paciente..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <div className="d-flex align-items-center gap-2">
                    <span className="small text-muted fw-bold text-uppercase" style={{ letterSpacing: '0.5px' }}>
                        Total Registros: <span className="text-dark bg-light px-2 py-1 rounded-pill">{filtered.length}</span>
                    </span>
                </div>
            </div>

            <div className="researcher-table-container">
                <div className="table-responsive">
                    <table className="researcher-table align-middle">
                        <thead>
                            <tr>
                                <th>Documento</th>
                                <th>Nombre Completo</th>
                                <th>Edad / Sexo</th>
                                <th>Proyecto</th>
                                <th>Ubicación de Campo</th>
                                <th>Contacto</th>
                                <th className="text-end">Acciones Científicas</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="7" className="text-center py-5">
                                    <div className="spinner-border spinner-border-sm text-success me-2"></div>
                                    <span className="text-muted fw-bold">Compilando base de datos...</span>
                                </td></tr>
                            ) : filtered.length === 0 ? (
                                <tr><td colSpan="7" className="text-center py-5 text-muted fw-bold">No se encontraron pacientes registrados en este proyecto.</td></tr>
                            ) : (
                                filtered.map(p => (
                                    <tr key={p.id}>
                                        <td className="fw-bold text-primary">{p.documento}</td>
                                        <td>{p.nombre}</td>
                                        <td>{p.edad} <span className="text-muted small">años</span> <span className="badge bg-light text-dark ms-1 shadow-xs" style={{ fontSize: '0.65rem' }}>{p.sexo}</span></td>
                                        <td><span className="badge border border-success text-success" style={{ fontSize: '0.7rem', background: '#f1f8e9' }}>{p.codigo_proyecto_investigacion || "N/A"}</span></td>
                                        <td>
                                            <div className="fw-bold">{p.municipio}</div>
                                            <div className="text-muted small" style={{ fontSize: '0.75rem' }}>{p.direccion}</div>
                                        </td>
                                        <td>
                                            <div className="small"><i className="bi bi-telephone-fill text-muted me-1"></i>{p.telefono || "N/A"}</div>
                                        </td>
                                        <td className="text-end">
                                            <div className="d-flex justify-content-end gap-1">
                                                <button className="btn btn-sm btn-light text-primary border" onClick={() => onViewHistory(p)} title="Historial Epidemiológico">
                                                    <i className="bi bi-clock-history"></i>
                                                </button>
                                                <button className="btn btn-sm btn-light text-success border" onClick={() => onEdit(p)} title="Editar Ficha">
                                                    <i className="bi bi-pencil-square"></i>
                                                </button>
                                                <button className="btn btn-sm btn-light text-danger border" onClick={() => setShowDeleteConfirm(p)} title="Eliminar Registro">
                                                    <i className="bi bi-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {showDeleteConfirm && (
                    <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ zIndex: 100, background: 'rgba(255,255,255,0.8)', backdropFilter: 'blur(4px)', borderRadius: '20px' }}>
                        <div className="card border-0 shadow-lg" style={{ maxWidth: '400px', borderRadius: '20px' }}>
                            <div className="card-body text-center p-4">
                                <div className="bg-danger bg-opacity-10 p-3 rounded-circle d-inline-block mb-3">
                                    <i className="bi bi-shield-exclamation text-danger fs-1"></i>
                                </div>
                                <h5 className="fw-bold text-dark">¿Validar Eliminación?</h5>
                                <p className="text-muted small">
                                    Está a punto de eliminar el registro clínico de <strong>{showDeleteConfirm.nombre}</strong>.
                                    Esta acción es irreversible y afectará la integridad de los datos del proyecto.
                                </p>
                                <div className="d-flex justify-content-center gap-2 mt-4">
                                    <button className="btn btn-light px-4 fw-bold" style={{ borderRadius: '10px' }} onClick={() => setShowDeleteConfirm(null)}>CANCELAR</button>
                                    <button className="btn btn-danger px-4 fw-bold" style={{ borderRadius: '10px' }} onClick={() => handleDelete(showDeleteConfirm.id)}>SÍ, ELIMINAR REGISTRO</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MisPacientes;

